export const formatNames = names => {
  if (!names) return

  const format = name => name.replace('*', '').replace(/\s+/g, ' ').trim()
  return names.map(name => format(name))
}
